import Reveal from './Reveal'

type PageHeroProps = {
  eyebrow: string
  title: string
  highlight: string
  copy?: string
  image: string
  imageWidth: number
  imageHeight: number
  position?: string
}

export default function PageHero({
  eyebrow,
  title,
  highlight,
  copy,
  image,
  imageWidth,
  imageHeight,
  position = 'center',
}: PageHeroProps) {
  return (
    <section className="page-hero">
      <img src={image} alt="" width={imageWidth} height={imageHeight} loading="eager" style={{ objectPosition: position }} aria-hidden="true" />
      <div className="page-hero-overlay" />
      <div className="site-container page-hero-content">
        <Reveal>
          <p className="eyebrow">{eyebrow}</p>
          <h1>{title} <span>{highlight}</span></h1>
          {copy && <p className="page-hero-copy">{copy}</p>}
        </Reveal>
      </div>
    </section>
  )
}
